import { ReactElement } from "react";
import { ActivityList } from "./List/ActivityList";
import styles from "./ActivityFeed.module.less";
import { setTrackingId } from "client/Misc/utils";

export const ActivityFeed = (): ReactElement => {
	return (
		<div
			{...setTrackingId("activity-feed")}
			className={styles.root}
		>
			<ActivityList />
		</div>
	);
};

ActivityFeed.displayName = "ActivityFeed";
